<template>
  <FontAwesomeIcon
    :icon="iconName"
    :size="computedConfig.size"
    :style="{ color: computedConfig.color }"
    :transform="computedConfig.transform"
    :spin="computedConfig.spin"
    :pulse="computedConfig.pulse"
    :border="computedConfig.border"
    :inverse="computedConfig.inverse"
    :pull="computedConfig.pull"
  />
</template>

<script setup>
import { defineProps } from "vue";
import { computed, markRaw } from "vue";
import { iconConfigs } from "@/components/app/icons/IconConfigs";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  config: {
    type: [String, Object],
    default: "base",
  },
});

const iconName = computed(() => ["fas", props.name]);
const computedConfig = computed(() => {
  let config = {};
  if (typeof props.config === "string") {
    config = iconConfigs[props.config] || iconConfigs.base;
  } else {
    config = { ...iconConfigs.base, ...props.config };
  }

  if (config.rotation) {
    config.transform = `rotate-${config.rotation}`;
  }

  return config;
});

// eslint-disable-next-line no-unused-vars
const iconComponent = markRaw(FontAwesomeIcon);
</script>
